import { graphql } from "api/cms-website/generated";

export const MainBannerExtraFragment = graphql(/* GraphQL */ `
    fragment MainBannerExtraFragment on ComponentComponentsMainBannerExtra {
        id
        noMarginBottom
        mainBannerExtraTitle: title
        invisalign
        disclaimer
        trustpilotLink {
            ...LinkFragment
        }
        mainBannerExtraAdvantages: advantages {
            ...TextFragment
        }
    }
`);
